import TimelineFullImage from '../../../../timeline/TimelineFullImage/TimelineFullImage';

const Image = require('../../../../../assets/img/timeline/modal/1994-conference.jpg');


const ConferenceContent = () => {
    return (
        <>
            <TimelineFullImage image={Image} />
            <h4>
                Australia’s first National Breast Cancer Consensus Conference
            </h4>
            <p>
                Australia’s first National Breast Cancer Consensus Conference, which BCT convened, was held in June 1994 on the Gold Coast and was opened by Mrs Annita Keating. The conference placed breast cancer firmly on the national health agenda, with several Breast Cancer Trials researchers in attendance at the meeting and involved in policy discussion on the future of breast cancer research.
            </p>
        </>
    );
}

export default ConferenceContent;